import {  useState } from 'react'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import { useTranslation } from 'react-i18next'
import ShopProducts from './ShopProducts'


const FeatureProducts = ({ products }) => {
  const { t} = useTranslation()
  // const currentLanguage = i18n.language
  // const isRTL = currentLanguage === 'ar' || currentLanguage === 'kr'
  

   const [styles, setStyles] = useState('grid')
   
 

  return (
    <div>
      {products && products.length > 0 ? (
        <section className='container bg-[#FBFBFB] py-2'>
          <div className="w-[68%] md:w-[80%] sm:w-[95%] lg:w-[95%] mt-8 h-full mx-auto">
            <div className="w-full flex justify-center items-center border-b-[1px]">
              <h2 className="text-xl font-semibold p-2 rounded-tl-lg rounded-tr-lg  text-slate-600 ">
                {t('home.discount_products')}{' '}
              </h2>
            </div>
            <div className="py-6 ">
              <ShopProducts products={products} styles={styles} />
            
            </div>

            <div className="w-full flex justify-center items-center py-4">
              <div className="custom_bullet justify-center gap-3 !w-auto"></div>
            </div>
          </div>
        </section>
      ) : null}
    </div>
  )
}

export default FeatureProducts
